module.exports = __webpack_public_path__ + "img/milestone-incomplete.e96bb3e0.svg";